export type DeliveryIntake = {
  id: string
  client_id?: string
  review_id: string
  arrived_at: string
  processing_state?: string
  processing_job_id?: string
  processing_error?: string
  status: 'processing' | 'review' | 'checked' | 'failed' | 'upload'
  created_by?: number
  created_at?: string
  attempt?: number
  candidate_only?: boolean
  has_unread_fields?: boolean
  recognition_repair_count?: number
  processing_progress?: import('../processing-progress').ProcessingProgress
  files?: { name: string; size?: number }[]
  documents?: { id: string; number?: string; file: string; lines: number; status: string; delivery_keys: string[] }[]
  document_count: number
  checked_count: number
  document_id?: string
  confirmed_at?: string
  accepted_delivery_keys?: string[]
  delivery_keys?: string[]
}
export type DeliveryAnalysis = DeliveryIntake & {
  delivery_key: string
  chat_id: string | null
  supplier: string
  document_number: string
  created_at: string
}
export type Delivery = {
  key: string
  deliveries?: Delivery[]
  uploadMode?: boolean
  dataset: 'orders' | 'requests'
  document_number: string
  supplier: string
  supplier_id?: string
  currency?: string
  warehouse: string
  planned_date: string | null
  source_date: string | null
  date_source: string
  plan_version: number
  source_active: boolean
  received_in_onec?: boolean
  received_at?: string
  partial: boolean
  position_count: number
  weight: { value: number | null; missing: number }
  area: { value: number | null; missing: number }
  amount?: { value: number | null; missing: number }
  requests: { number: string; wd_number: string }[]
  items: Record<string, unknown>[]
  intakes: DeliveryIntake[]
}
export const isDeliveryAccepted = (delivery: Delivery) => !!delivery.received_in_onec || (delivery.intakes || []).some(intake =>
  intake.status === 'checked' && (intake.accepted_delivery_keys || []).includes(delivery.key),
)
export const canReceiveDelivery = (delivery: Delivery) => delivery.source_active && !isDeliveryAccepted(delivery)
export const deliveryStatus = (delivery: Delivery) => {
  if (delivery.received_in_onec) return { text: 'Принято в 1С', color: 'green' }
  if (isDeliveryAccepted(delivery)) return { text: 'Приёмка подтверждена', color: 'green' }
  const current = delivery.intakes[0]
  const pending = delivery.intakes.filter(row => row.status === 'processing'
    || (!row.document_count && !['failed', 'cancelled', 'uploading'].includes(row.processing_state || '')))
  const ready = delivery.intakes.filter(row => row.document_count && row.status !== 'processing')
  if (pending.length) return { text: ready.length ? `Готово: ${ready.length} · в работе: ${pending.length}` : pending.some(row => row.processing_state === 'awaiting_result') ? 'Дольше обычного' : pending.some(row => row.processing_state === 'repairing') ? 'Уточняем данные' : 'Идёт разбор', color: 'blue' }
  if (delivery.intakes.some(row => row.processing_state === 'failed')) return { text: ready.length ? `Готово: ${ready.length} · есть ошибка` : 'Ошибка разбора', color: 'red' }
  if (current?.candidate_only) return { text: 'Проверить связь', color: 'gold' }
  if (current?.document_count && current.checked_count === current.document_count) return { text: 'Накладные проверены', color: 'gold' }
  if (current?.status === 'review') return { text: 'Готово к проверке', color: 'gold' }
  if (current?.processing_state === 'failed') return { text: 'Ошибка разбора', color: 'red' }
  if (current?.processing_state === 'queued') return { text: 'В очереди', color: 'blue' }
  if (current?.processing_state === 'uploading' || current?.processing_state === 'cancelled') return { text: 'Документы не отправлены', color: 'default' }
  if (current) return { text: 'Идёт разбор', color: 'blue' }
  return { text: delivery.partial ? 'Ожидается остаток' : 'Ожидается', color: 'default' }
}
